<template>
  <select class="form-control" :required="true" v-model="selected" @change="la_schimb">
   <option v-for="([key, value]) in Object.entries(options)" v-bind:key="key" v-bind:value="key">{{ value }}</option>
  </select>
</template>

<script>
export default {
    name: 'FSelectObj',
    data () {
        return {
        selected: "-1",
        }
    },
    props: ["options", "initial"],
    methods:{
        la_schimb: function(){
            this.$emit('fselectobj', this.selected)
        }
           
    },
    mounted(){
        this.$emit('fselectobj', this.initial)
        this.selected = this.initial
    }
    

}
</script>
